<header></header>
<div class="flex justify-center gap-4 bg-[#F8F9FA] py-6 sm:pl-6">
  <!-- main content-->
  <main>
    <router-outlet></router-outlet>
  </main>
</div>

<footer></footer>
